import { Link } from 'react-router-dom';

interface SectionHeadingProps {
  title: string;
  subtitle?: string;
  moreLink?: string;
  moreText?: string;
  accent?: boolean;
}

export default function SectionHeading({
  title,
  subtitle,
  moreLink,
  moreText = '查看全部',
  accent = false,
}: SectionHeadingProps) {
  return (
    <div className="flex items-end justify-between gap-4 mb-5 md:mb-7">
      <div className="min-w-0">
        <div className="flex items-center gap-3">
          <span className={`block w-1 h-5 rounded-full ${accent ? 'bg-accent-500' : 'bg-primary-500'}`} />
          <h2 className="text-xl md:text-2xl font-bold text-foreground-50 tracking-tight">{title}</h2>
        </div>
        {subtitle && <p className="mt-2 text-sm text-foreground-400 pl-4">{subtitle}</p>}
      </div>
      {moreLink && (
        <Link
          to={moreLink}
          className="hidden sm:inline-flex items-center gap-1 text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap"
        >
          {moreText}
          <i className="ri-arrow-right-s-line text-lg" />
        </Link>
      )}
    </div>
  );
}